import inventoryText from "../inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import ProductTable from "./ProductsTable";
import Modal from "react-bootstrap/Modal";
import AddProduct from "./ProductAdd";
import "./ProductEdit.css";

import AuthContext from "../../context/AuthContext";
import axios from "axios";
import { API_URL } from "../../components/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faUser,
  faWifi,
  faList,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";

function PlansRes() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [user.username]);
  return (
    <div className="Plans">
      <div className="main">
        <div>
          <button onClick={handleShow} className="AddClient">{inventoryText("inventory.AddProduct")}</button>

          <NavLink
            exact
            to="/inventory/products/categories"
            activeClassName="active"
            className="AddClient"
          >{inventoryText("inventory.Categories")}</NavLink>

          <NavLink
            exact
            to="/inventory"
            activeClassName="active"
            className="AddClient"
          >{inventoryText("inventory.GoBack")}</NavLink>
        </div>
        <ProductTable />
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        className="product-edit-modal product-add-modal"
      >
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{inventoryText("inventory.AddProduct")}</Modal.Title>
          </Modal.Header>
          <AddProduct />
        </div>
      </Modal>
    </div>
  );
}

export default PlansRes;
